var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input-pop pop" }, [
    _c("div", { staticClass: "pop-box" }, [
      _c("div", { staticClass: "pop-main" }, [
        _c("div", { staticClass: "pop-main-top" }, [
          _vm._v(_vm._s(_vm.titleMsg))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pop-main-test" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newFolderName,
                expression: "newFolderName"
              },
              { name: "focus", rawName: "v-focus" }
            ],
            ref: "input",
            class: { error: _vm.noInput },
            attrs: {
              type: "text",
              placeholder: _vm.$t("operation.floderName")
            },
            domProps: { value: _vm.newFolderName },
            on: {
              keyup: _vm.onChange,
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.newFolderName = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pop-main-bottom" }, [
          _c(
            "button",
            { staticClass: "btn-black", on: { click: _vm.newFolder } },
            [_vm._v(_vm._s(_vm.$t("operation.confirm")))]
          ),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "btn-grey", on: { click: _vm.closeInputPop } },
            [_vm._v(_vm._s(_vm.$t("list.cancel")))]
          )
        ])
      ]),
      _vm._v(" "),
      _c("i", { staticClass: "icon-close", on: { click: _vm.closeInputPop } })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-952c13b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-952c13b2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Et/InputPop.vue
// module id = null
// module chunks = 